import api from "../../../api/axiosInstance";

export const getMinorAilments = (patientId, filter) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await api.post(`/medicalSummary/minorAilments`, {
        patientId: patientId,
        filter: filter
      });
      const data = response.data;
      dispatch({ type: "GET_MINOR_AILMENTS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({ type: "GET_MINOR_AILMENTS_FAILURE", payload: error.message });
    }
  };
};

export const setLoading = (isLoading) => {
  return async (dispatch) => {
    dispatch({ type: "SET_LOADING", payload: isLoading });
  };
};

export const getMedicationReview = (patientId, filter) => {

  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await api.post(`/medicalSummary/medicationReviews`, {
        patientId: patientId,
        filter: filter
      });
      const data = response.data;
      dispatch({ type: "GET_MEDICATION_REVIEW_SUCCESS", payload: data });
    } catch (error) {
      dispatch({ type: "GET_MEDICATION_REVIEW_FAILURE", payload: error.message });
    }
  };
};

export const getNotes = (patientId, filter) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await api.post(`/medicalSummary/patientChartsNotePads`, {
        patientId: patientId,
        filter: filter
      });
      const data = response.data;
      dispatch({ type: "GET_NOTES_SUCCESS", payload: data });
    } catch (error) {
      dispatch({ type: "GET_NOTES_FAILURE", payload: error.message });
    }
  };
};

export const setSelectedMedicalSummary = (record) => {
  return {
    type: "SET_SELECTED_MEDICAL_SUMMARY",
    payload: record
  };
};

export const setSelectedRowId = (rowId) => {
  return {
    type: "SET_SELECTED_ROW_ID",
    payload: rowId
  };
};
